import React from 'react';
import styles from './About.module.css';
import Button from '../Shared/Button';

const About = () => {
  return (
    <section className={styles.about}>
      <div className={styles.container}>
        <div className={styles.content}>
          <h2 className={styles.heading}>Почему 2026 год особенный и как он повлияет на ваше будущее</h2>
          <div className={styles.text}>
            <p>
              Вы, наверное, слышали, что некоторые годы в китайской метафизике считаются более важными, чем другие. 2026 год - один из таких. Это Год Огненной Лошади, 9-й период в 180-летнем цикле. Переходный период, который случается раз в несколько десятилетий. Что это значит для вас лично? Решения, которые вы примете в 2026 году, их последствия и результаты будут влиять на вашу жизнь на протяжении следующих 60+ лет. Представьте: выбор, который вы сделаете сегодня, будет определять ваше будущее до 2086 года и дальше.
            </p>
            <img 
              src="https://strategy.annavision.me/wp-content/uploads/2025/12/cdc2ef57cc7577afda5b23de7d3b0365_1766894560-1.png" 
              alt="Китайские символы удачи 風杏凰" 
              className={styles.inlineSymbols}
            />
            <p>
              В такие периоды особенно важно действовать правильно и в нужное время. Один неправильный шаг может отбросить вас назад на месяцы или даже годы. Одно правильное решение в нужный момент может открыть перед вами возможности на десятилетия вперед. Именно поэтому планирование 2026 года требует максимальной осторожности и осознанности. Вы не можете позволить себе действовать наугад или полагаться только на интуицию. 
            </p>
            <p>
              Вам нужен персональный навигатор, который подскажет, когда действовать, а когда замедлиться, какие направления выбирать, а каких избегать, когда инвестировать, а когда экономить. Этот год запомнится на всю жизнь. Важно сделать так, чтобы вы запомнили его как год вашего прорыва, а не как год упущенных возможностей или серьезных ошибок.
            </p>
          </div>
          <div className={styles.cta}>
            <Button onClick={() => document.querySelector('[data-section="pricing"]')?.scrollIntoView({ behavior: 'smooth' })}>
              Начать планирование 2026 года
            </Button>
          </div>
        </div>
        <div className={styles.imageWrapper}>
          <img 
            src="https://strategy.annavision.me/wp-content/uploads/2025/12/7ae685a685b94a090a0f4fed8c6a566a_1766897963_6dh2gjfx-1.webp" 
            alt="Приглашение в лучшую жизнь - рука в атласной перчатке держит карту" 
            className={styles.aboutImage}
          />
        </div>
      </div>
    </section>
  );
};

export default About;

